import { BaseService } from "../../base";
export class InterconsultService extends BaseService {
  static get entity() {
    return "interconsult";
  }
  static get name() {
    return "interconsult";
  }
  static async getByMaActivityId(ma_activity) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_ma_activity_id/${ma_activity}`);
  }
  static async findByPatientPaginate(patient_id, page = 1) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_patient_paginate/${patient_id}?page=${page}`);
  }
  static async findByOriginNodeId(origin_node_id, page = 1) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_origin_id/${origin_node_id}?page=${page}`, null);
  }
  static async findByOriginNodeIdAndPatientId(origin_node_id, patient_id, page = 1) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_origin_id_patient_id/${origin_node_id}/${patient_id}?page=${page}`,
      null
    );
  }
  static async findByStateStepNode(state, step, node, page = 1) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_node/${state}/${step}/${node}?page=${page}`);
  }
  static async findByStateStepDestination(state, step, destination_node_id, page = 1) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_paginate/${state}/${step}/${destination_node_id}?page=${page}`
    );
  }
  static async findByStateStepOrigin(state, step, origin_node_id, order, page = 1) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_origin_paginate/${state}/${step}/${origin_node_id}/${order}?page=${page}`
    );
  }
  static async findByStateStepOriginFilter(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_origin_paginate_filter`, this.name, data);
  }
  static async findByStateStepFilter(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_paginate_filter`, null, data);
  }
  static async findByStateStepFilterCg(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_paginate_filter_cg`, null, data);
  }
  static async getRptStateStepFilterCg(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_paginate_filter_cg_export`, null, data, {
      responseType: "blob",
    });
  }
  static async findByStateStepOrFilter(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_or_filter`, null, data);
  }
  static async findByStateStepOrFilterOrigin(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_or_filter_origin`, null, data);
  }
  static async findByStateStepOrOriginByOrder(state, step, destination, order, page) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_or_origin_by_order/${state}/${step}/${destination}/${order}?page=${page}`,
      null
    );
  }
  static async findByStateNodePatientOrigin(state, node, patient, page) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_node_patient_id_origin/${state}/${node}/${patient}?page=${page}`,
      null
    );
  }
  static async findByStateStepOrOrigin(state, step, destination, page) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_or_origin/${state}/${step}/${destination}?page=${page}`,
      null
    );
  }
  static async findByStateSpecialtyNodeOrigin(state, specialty, node, page) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_specialty_node_origin/${state}/${specialty}/${node}?page=${page}`,
      null
    );
  }
  //Busca según el destination_node_id de la IC y que tenga interconsult_citations
  static async findByStateStepNodeHasIcDestinationNode(destination_node_id, page) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_node_hasic_destination_node/${destination_node_id}?page=${page}`,
      null
    );
  }
  //Busca según el destination_node_id, service_node_id de la IC y que tenga interconsult_citations
  static async findByStateStepNodeHasIcService(destination_node_id, service_node_id, page) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${
        this.entity
      }/find_by_state_step_node_hasic_service_destination/${destination_node_id}/${service_node_id}?page=${page}`,
      null
    );
  }
  //Busca según el destination_node_id, service_node_id, ges de la IC y que tenga interconsult_citations
  static async findByStateStepNodeHasIcServiceGes(destination_node_id, service_node_id, ges, page) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${
        this.entity
      }/find_by_state_step_node_hasic_service_ges_node/${destination_node_id}/${service_node_id}/${ges}?page=${page}`,
      null
    );
  }
  //Busca según el destination_node_id, ges de la IC y que tenga interconsult_citations
  static async findByStateStepNodeHasIcGesNode(destination_node_id, ges, page) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_node_hasic_ges_node/${destination_node_id}/${ges}?page=${page}`,
      null
    );
  }
  static async findByStateNodeFilter(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_node_filter`, null, data);
  }
  static async findByStateStepDestinationGes(state, step, destination_node_id, ges, page = 1) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_paginate_ges/${state}/${step}/${destination_node_id}/${ges}?page=${page}`
    );
  }
  static async findByStateStepOriginGes(state, step, origin_node_id, ges, page = 1) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_origin_paginate_ges/${state}/${step}/${origin_node_id}/${ges}?page=${page}`
    );
  }
  static async getByStateUser(state, user_id, page) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_user_id_state/${state}/${user_id}?page=${page}`);
  }
  /**
   * Entrega las SIC según rut del profesional que realizó la SIC, el nodo de origen y el estado actual de la ic
   * @param {string} rut Corresponde al campo rut_prof
   * @param {number} node corresponse al campo origin_node_id
   * @param {string} state Corresponde al campo state
   * @returns
   */
  static async getByRutNodeState(rut, node, state, page) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_rut_and_node_state/${rut}/${node}/${state}?page=${page}`);
  }
  static async getByUserAccepted(user_id, page) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_user_id_accepted/${user_id}?page=${page}`);
  }

  static async findByStateStepNodeHasic(state, step, node, state2, page = 1) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_node_hasic/${state}/${step}/${node}/${state2}?page=${page}`
    );
  }
  static async getByStateStepNodeDoesnthaveicService(state, step, node, service, state2, page) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${
        this.entity
      }/find_by_state_step_node_doesnthaveic_service/${state}/${step}/${node}/${service}/${state2}?page=${page}`
    );
  }
  static async findByStateStepNodeHasicGes(state, step, node, state2, ges, page = 1) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_node_hasic_ges/${state}/${step}/${node}/${state2}/${ges}?page=${page}`
    );
  }
  static async findByStateStepNodeDoesntHaveic(state, step, node, state2, page = 1) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_node_doesnthaveic/${state}/${step}/${node}/${state2}?page=${page}`
    );
  }
  static async findByStateStepNodeDoesntHaveicGes(state, step, node, state2, ges, page = 1) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_node_doesnthaveic_ges/${state}/${step}/${node}/${state2}/${ges}?page=${page}`
    );
  }
  static async getByStateStepNodeDoesnthaveicServiceGes(state, step, node, service, state2, ges, page) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${
        this.entity
      }/find_by_state_step_node_doesnthaveic_service_ges/${state}/${step}/${node}/${service}/${state2}/${ges}?page=${page}`
    );
  }
  static async getByStateStepNodeHasicService(state, step, node, service, state2, page) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_node_hasic_service/${state}/${step}/${node}/${service}/${state2}?page=${page}`
    );
  }
  static async getByStateStepNodeHasicServiceGes(state, step, node, service, state2, ges, page) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${
        this.entity
      }/find_by_state_step_node_hasic_service_ges/${state}/${step}/${node}/${service}/${state2}/${ges}?page=${page}`
    );
  }

  static async getFindByStateStepNodeDoesntHaveicPost(payload, page) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_node_doesnthaveic_post?page=${page}`, null, payload);
  }
  static async getFindByStateStepNodeHaveicPost(payload, page) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_node_haveic_post?page=${page}`, null, payload);
  }
  static async filterAll(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/filter_all`, null, payload);
  }

  /**
   * Filtra las ics en el perfil medic_hosp
   * @param {
   *  patient_id int -> es el id del paciente al cual está asociada la ic / obligatorio
   *  destination_node_id int -> es el id del establecimiento de destino al cual está dirigida la ic / obligatorio
   *  state string -> es el estado de la ic
   *  state_interconsult string -> es el state de states_interconsults
   *  step_state_interconsult string -> es el step de states_interconsults
   * } data
   * @param {int} page
   * @returns
   */
  static async getByDestinationFilter(data, page) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_destination_filter?page=${page}`, null, data);
  }

  /**
   * @param {Object} data
   * @param {Number | String | Null} data.node_id
   * @param {String | Null} data.rut?
   * @param {Number | Null} data.service_node_id
   * @param {Number | Null} data.patient_id
   * @param {Number | Null} data.origin_node_id?
   * @param {Boolean | Null} data.is_not_discharged
   * @param {Boolean | Null} data.is_authorized
   * @param {Boolean | Null} data.has_not_medical_admission
   * @param page
   * @returns {Promise<unknown>}
   */
  static async filterByAll(data, page) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/filter_all?page=${page}`, null, data);
  }

  /**
   * Filtra las ics en el perfil medic_hosp
   * @param {
   *  patient_id int -> es el id del paciente al cual está asociada la ic / obligatorio
   *  destination_node_id int -> es el id del establecimiento de destino al cual está dirigida la ic / obligatorio
   *  state string -> es el estado de la ic
   *  state_interconsult string -> es el state de states_interconsults
   *  step_state_interconsult string -> es el step de states_interconsults
   * } data
   * @param {int} page
   * @returns
   */
  static async getByOriginFilter(data, page) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_origin_filter?page=${page}`, null, data);
  }

  /**
   * Filtra las sic según el estado en interconsult_citation
   * @param {
   *  destination_node_id int -> es el id del nodo de destino de la sic / obligatorio
   *  state string -> es el estado de interconsult_citation / obligatorio
   *  state_interconsult string -> es el state de states_interconsults / obligatorio
   *  step_interconsult string -> es el step de states_interconsults / obligatorio
   *  ges string -> es el tipo de GES (SI/NO)
   *  service_node_id -> es el id del nodo de destino
   * } data
   * @param {int} page
   * @returns
   */
  static async getByInterconsultCitationState(data, page) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_interconsult_citation_state?page=${page}`, null, data);
  }

  static async getByRequestDate(date) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_request_date/${date}`, null);
  }

  static async egressSicByNsp(schedule_citation_id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/egress_sic_by_nsp/${schedule_citation_id}`, null);
  }

  static async getUpdateIsReviewed(id, data) {
    return this.submit("put", `${this.getApiUrlEntity(this.profile)}${this.entity}/update_isreviewed/${id}`, this.name, data);
  }
  static async updateNoValidation(id, data) {
    return this.submit("put", `${this.getApiUrlEntity(this.profile)}${this.entity}/update_novalidation/${id}`, this.name, data);
  }

  static async updateState(id, state) {
    return this.submit("put", `${this.getApiUrlEntity(this.profile)}${this.entity}/update_state/${id}`, this.name, {
      state: state,
    });
  }

  /**
   * Filtra las sic que no tengan ni interconsults_citations ni schedule_citations, además de todo lo de abajo
   * @param {
   *  state string -> es el estado de states_interconsults
   *  step string -> es el step de states_interconsults
   *  node int -> es el destination_node_id de la ic
   *  service_id int -> es el service_node_id de la ic
   *  step2 string -> es el step de states_interconsults que se ocupa en el orWhere (no recuerdo por que era así :/)
   *  patient_id int -> es el id del paciente que está en ic
   * } data
   * @param {int} page
   * @returns
   */
  static async icsReadyForCitation(data, page = 1) {
    return this.submit(
      "post",
      `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_step_node_doesnthaveic_service_patient?page=${page}`,
      null,
      data
    );
  }

  /**
   * @param {
   *  destination_node_id int -> es el id del nodo de destino de la sic / obligatorio
   *  is_authorized boolean -> ics que tengan registro en la tabla accept_interconsults
   *  is_egressed boolean -> ics que tengan registro en la tabla egress_interconsults
   *  service_node_id int -> es el service_node_id de la ic
   *  is_pending boolean -> ics que tengan como estado "active" o "enviada"
   *  pending_contrarref boolean -> ics que tengan registro en la tabla accept_interconsults y no tengan registro en la tabla contrarrefs
   *  has_contrarref boolean -> ics que tengan registro en la tabla contrarrefs
   * } data
   * @returns
   */
  static async getByDashboardFilter(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_destination_filter_dashboard`, null, data);
  }
  /**
   * @param {
   *  destination_node_id int -> es el id del nodo de destino de la sic / obligatorio
   *  is_authorized boolean -> ics que tengan registro en la tabla accept_interconsults
   *  is_egressed boolean -> ics que tengan registro en la tabla egress_interconsults
   *  service_node_id int -> es el service_node_id de la ic
   *  is_pending boolean -> ics que tengan como estado "active" o "enviada"
   *  pending_contrarref boolean -> ics que tengan registro en la tabla accept_interconsults y no tengan registro en la tabla contrarrefs
   *  has_contrarref boolean -> ics que tengan registro en la tabla contrarrefs
   * } data
   * @returns
   */
  static async filterComptroller(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/filter_comptroller`, null, data);
  }

  static async updatePriority(id, data) {
    return this.submit("put", `${this.getApiUrlEntity(this.profile)}${this.entity}/update_priority/${id}`, null, data);
  }

  static async performedActivities(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/performed_activities`, null, data);
  }

  static async completeHistory(interconsult_id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/complete_history/${interconsult_id}`, "response");
  }
  static async reportSicFilter(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/report_sic_filter`, null, payload, {
      responseType: "blob",
    });
  }
  static async consecutiveNspSIC(schedule_citation_id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/consecutive_nsp_sic/${schedule_citation_id}`, null);
  }
  static async getCreatedInAttention(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/created_in_attention`, null, data);
  }
  static async update_ges(id, payload) {
    return this.submit("put", `${getApiUrlEntity(this.profile)}${this.entity}/update_ges/${id}`, this.name, payload);
  }
}
